<template>
  <div class="progress-bar-illustration" :class="[cashflowCategory, { 'grayed-out': grayedOut }]">
    <div class="progress" :class="[cashflowCategory, { 'grayed-out': grayedOut }]" :style="{ width: `${barWidthPercent}%` }"></div>
  </div>
</template>

<script>
import _ from 'lodash';
import cashflowViewConsts from '../constants/cashflow-view';

export default {
  name: 'AnimatedBar',
  props: {
    totalAmount: {
      required: true,
    },
    cashflowCategory: {
      type: String,
      required: false,
      validator: val => _.values(cashflowViewConsts.CASHFLOW_CATEGORIES).includes(val),
    },
    grayedOut: {
      type: Boolean,
      required: false,
      default: false,
    },
    upToNowAmount: {
      required: true,
    },
  },
  data() {
    return {
      tweeningTotalAmountValue: 0,
    };
  },
  computed: {
    barWidthPercent() {
      return _.min([Math.floor((this.upToNowAmount / this.totalAmount) * 100), 100]);
    },
  },
};
</script>

<style scoped lang="scss">
  @import '../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../scss/category-color-mixins';

  .progress-bar-illustration {
    height: 15px;
    width: 100%;
    border-radius: 19px;
    @include category-background-color-light;

    &.grayed-out {
      background-color: $riseup_gray_0;
    }

    .progress {
      height: 100%;
      transition: width 1s;
      border-radius: 25px;
      @include category-background-color;

      &.grayed-out {
        background-color: $riseup_gray_1;
      }
    }
  }
</style>
